import React, { useState, useEffect, useRef, Component } from "react";
import { View, Text, StyleSheet, ImageBackground, TouchableOpacity, SafeAreaView, Dimensions, Linking, ScrollView, Image, TextInput, Button } from "react-native";
import Modal from "react-native-modal";
import { useNavigation, useRoute } from "@react-navigation/native";
import i18n from "./i18n";
import AsyncStorage from "./AsyncStorage";
import RNPickerSelect from "react-native-picker-select";

const { width } = Dimensions.get("window");

function mLoginHeader(props) {
    const navigation = useNavigation();
    const route = useRoute();

    const [isLoading, setIsLoading] = useState(false);
    const [language, setLanguage] = useState("");
    const [languageErr, setLanguageErr] = useState(false);
    const [drawerOverlay, setDrawerOverlay] = useState(false);
    const [langSwitch, setLangSwitch] = useState(false); // Language switching modal handling
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;

        AsyncStorage.getData("mCode").then((value) => {
            // console.log(route.name);
            if (route.name == "Login") {
                AsyncStorage.removeValue("mCode");
            }

            // else if (!value) {
            //   navigation.push("Login");
            // }

            AsyncStorage.getData("mCode").then((value) => {
                if (value) {
                    setIsLoggedIn(true);
                }
            });
        });

        return () => {
            mounted.current = false;
        };
    }, []);

    const drawerChangePage = (pageName) => {
        navigation.push(pageName);
        setDrawerOverlay(false);
    };

    const switchLang = (lang) => {
        i18n.locale = lang;
        AsyncStorage.storeData("lang", lang);
        location.reload();
    };

    const switchLangV1 = (lang) => {
        console.log(lang);
        setIsLoading(true);
        setLanguageErr(false);

        if (language == "") {
            setLanguageErr(true);
            setIsLoading(false);
            return;
        }

        i18n.locale = lang;
        console.log("current language :", lang);

        AsyncStorage.storeData("lang", lang);
        // location.reload();
        // Updates.reloadAsync();

        navigation.replace(
            route.name, // current page/screen
            null, // no params
            null, // no "sub-action"
            Math.random().toString()
        );

        setIsLoading(false);
        setLangSwitch(false);
    };

    const logoutHandling = () => {
        AsyncStorage.removeValue("mCode");
        // Updates.reloadAsync();
        navigation.push("Login");
        setDrawerOverlay(false);
    };

    return (
        <View className="w-full md:hidden absolute top-6 left-0 z-50">
            <View className="flex flex-row justify-between items-center w-full my-1">
                <View>
                    <TouchableOpacity onPress={() => setDrawerOverlay(true)}>
                        <ImageBackground source={require("../assets/burger-btn.png")} resizeMode="contain" className="w-10 h-10 ml-6" />
                    </TouchableOpacity>
                </View>
            </View>

            <Modal
                // isVisible={this.state.isModalVisible}
                // onBackdropPress={this.toggleSideMenu} // Android back press
                // onSwipeComplete={this.toggleSideMenu} // Swipe to discard
                isVisible={drawerOverlay}
                animationIn="slideInLeft" // Has others, we want slide in from the left
                animationOut="slideOutLeft" // When discarding the drawer
                onSwipeComplete={() => setDrawerOverlay(false)}
                onBackdropPress={() => setDrawerOverlay(false)}
                swipeDirection="left" // Discard the drawer with swipe to left
                // useNativeDriver // Faster animation
                hideModalContentWhileAnimating // Better performance, try with/without
                propagateSwipe // Allows swipe events to propagate to children components (eg a ScrollView inside a modal)
                backdropOpacity={0.5}
                style={drawerStyles.sideMenuStyle} // Needs to contain the width, 75% of screen width in our case
            >
                <View className="bg-[#CAB180] h-screen flex align-middle pt-7 pl-8">
                    <View className="h-10 mb-4 items-start justify-center">
                        <TouchableOpacity onPress={() => setDrawerOverlay(false)}>
                            <ImageBackground source={require("../assets/burger-btn.png")} resizeMode="contain" className="w-10 h-10" />
                        </TouchableOpacity>
                    </View>

                    <View>
                        {isLoggedIn && (
                                      <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("Profile")}>
                                        <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.home")}</Text>
                                      </TouchableOpacity>
                                    )}
                        
                                    {isLoggedIn == false && (
                                      <TouchableOpacity className="w-auto h-8 max-h-8 my-2 " onPress={() => drawerChangePage("SignUp")}>
                                        <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.register")}</Text>
                                      </TouchableOpacity>
                                    )}
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2 " onPress={() => drawerChangePage("AboutUs")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.aboutUs")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("Privilege")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.privileges")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => Linking.openURL("https://www.imperialtreasure.com.cn/china/LG-en/happenings")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.highlights")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("Outlets")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.restaurants")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2 hidden" onPress={() => drawerChangePage("Reservation")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.reservations")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("FAQ")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.faqs")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("Tnc")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.termsAndPrivacy")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => Linking.openURL("https://www.imperialtreasure.com.cn/china/contact")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.contact")}</Text>
                                    </TouchableOpacity>
                        
                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => drawerChangePage("LanguageSetting")}>
                                      <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.language")}</Text>
                                    </TouchableOpacity>

                                    <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => switchLang(i18n.locale == "zh" ? "en" : "zh")}>
                                    <Text className="uppercase text-black text-xl font-bold font-Crimson">{i18n.locale == "zh" ? "ENG" : "中文"}</Text>
                                    </TouchableOpacity>
                        
                                    {isLoggedIn && (
                                      <TouchableOpacity className="w-auto h-8 max-h-8 my-2" onPress={() => logoutHandling()}>
                                        <Text className="text-black text-xl font-bold font-Crimson">{i18n.t("mbHeader.logout")}</Text>
                                      </TouchableOpacity>
                                    )}
                        
                                    {/* <View className="flex flex-row justify-start items-center flex-wrap mt-8 mb-1">
                                      <TouchableOpacity
                                        onPress={() => {
                                          Linking.openURL("https://m.facebook.com/imperialtreasuresg");
                                        }}
                                      >
                                        <ImageBackground source={require("../assets/icons/fb-icon.png")} resizeMode="contain" className="w-6 h-6"></ImageBackground>
                                      </TouchableOpacity>
                        
                                      <TouchableOpacity
                                        onPress={() => {
                                          Linking.openURL("https://www.instagram.com/imperialtreasuresg/");
                                        }}
                                      >
                                        <ImageBackground source={require("../assets/icons/ig-icon.png")} resizeMode="contain" className="w-6 h-6 ml-4"></ImageBackground>
                                      </TouchableOpacity>
                                    </View> */}
                    </View>
                </View>
            </Modal>
        </View>
    );
}

const drawerStyles = StyleSheet.create({
    sideMenuStyle: {
        margin: 0,
        width: width * 0.75, // SideMenu width
    },
});

const pickerSelectStyles = StyleSheet.create({
    inputIOS: {
        color: "#86909C",
        height: 34,
        width: "100%",
        borderWidth: 1,
        borderColor: "#F2F3F5",
        backgroundColor: "#F2F3F5",
        paddingHorizontal: 15,
        borderRadius: 0,
    },
    inputAndroid: {
        color: "#86909C",
        height: 38,
        fontSize: 15,
        lineHeight: 38,
        width: "100%",
        backgroundColor: "#F2F3F5",
        borderColor: "#F2F3F5",
        borderWidth: 1,
        paddingHorizontal: 15,
    },
    inputWeb: {
        color: "#86909C",
        height: 34,
        width: "100%",
        borderWidth: 1,
        borderColor: "#F2F3F5",
        backgroundColor: "#F2F3F5",
        paddingHorizontal: 15,
        borderRadius: 0,
    },
});

export default mLoginHeader;
